import { getTerminalConfig } from "../config/terminalConfig";
import { getIsMasterTablet } from "./browser/localStorage";

export const shouldEnableFeature = (toggle: string) => {
	const appMode = getTerminalConfig().build.env;
	const isMasterTablet = getIsMasterTablet();

	if (!isMasterTablet) {
		return false;
	}

	if (appMode === "production") {
		return true;
	}
	if (appMode === "staging") {
		const hasStagingOverride = new URLSearchParams(window.location.search).get(toggle);
		return hasStagingOverride === "true";
	}

	return false;
};
